import {
  ArrowLeftIcon,
  ArrowPathIcon,
  RocketLaunchIcon,
} from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';

const CONFIRMATION_TEXT = 'CONVERT ORDER';

function ConvertOrderConfirmation({
  confirmationText,
  onConfirmationTextChange,
  onSubmit,
  onBack,
  isLoading,
}) {
  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <label className="mb-2 block font-semibold text-gray-900 text-sm">
          Final Confirmation
        </label>
        <input
          type="text"
          value={confirmationText}
          onChange={(e) => onConfirmationTextChange(e.target.value)}
          required
          placeholder={`Type '${CONFIRMATION_TEXT}' to confirm`}
          className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500 sm:text-sm"
        />
        <p className="mt-2 text-gray-500 text-xs">
          Type exactly "{CONFIRMATION_TEXT}" to proceed with the conversion
        </p>
      </div>

      <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 font-medium text-gray-700 text-sm shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          <ArrowLeftIcon className="mr-2 h-4 w-4" />
          Back
        </button>
        <button
          type="button"
          onClick={onSubmit}
          disabled={isLoading || confirmationText !== CONFIRMATION_TEXT}
          className="inline-flex items-center justify-center rounded-lg border border-transparent bg-red-600 px-6 py-2 font-medium text-sm text-white shadow-sm transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isLoading ? (
            <>
              <ArrowPathIcon className="mr-2 h-4 w-4 animate-spin" />
              Converting...
            </>
          ) : (
            <>
              <RocketLaunchIcon className="mr-2 h-4 w-4" />
              Convert to Courtesy
            </>
          )}
        </button>
      </div>
    </div>
  );
}

ConvertOrderConfirmation.propTypes = {
  confirmationText: PropTypes.string.isRequired,
  onConfirmationTextChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ConvertOrderConfirmation;
